/** ***********
*
* <kpi.module.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  PEREIRA Thomas [SOPRA STERIA] [thomas.pereira@soprasteria.com]
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
 * All rights reserved.
**************/

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AppMaterialModule } from '../../material.modules';
import { OrderbyModule } from '../shared/orderby/orderby.module';
import { KpiCycleTimeMonitoringComponent } from './kpi-cycle-time-monitoring/kpi-cycle-time-monitoring.component';
import { KpiFilterComponent } from './kpi-filter/kpi-filter.component';
import { KpiInOutZoneMonitoringComponent } from './kpi-in-out-zone-monitoring/kpi-in-out-zone-monitoring.component';
import { KpiLoopTimeMonitoringComponent } from './kpi-loop-time-monitoring/kpi-loop-time-monitoring.component';
import { KpiStaticTimeMonitoringComponent } from './kpi-static-time-monitoring/kpi-static-time-monitoring.component';
import { KpiTimeInZoneMonitoringComponent } from './kpi-time-in-zone-monitoring/kpi-time-in-zone-monitoring.component';
import { KpiComponent } from './kpi.component';
import { SharedModule } from '../shared/shared.module';
import { BarAssetsCycleComponent } from './kpi-cycle-time-monitoring/bar-assets-cycle/bar-assets-cycle.component';
import { BarCyclesCycleComponent } from './kpi-cycle-time-monitoring/bar-cycles-cycle/bar-cycles-cycle.component';
import { BarFamilyCycleComponent } from './kpi-cycle-time-monitoring/bar-family-cycle/bar-family-cycle.component';
import { BarZonesCycleComponent } from './kpi-cycle-time-monitoring/bar-zones-cycle/bar-zones-cycle.component';
import { TrendFamilyCycleComponent } from './kpi-cycle-time-monitoring/trend-family-cycle/trend-family-cycle.component';
import { TrendZoneCycleComponent } from './kpi-cycle-time-monitoring/trend-zone-cycle/trend-zone-cycle.component';
import { BarAssetLoopComponent } from './kpi-loop-time-monitoring/bar-asset-loop/bar-asset-loop.component';
import { BarCycleLoopComponent } from './kpi-loop-time-monitoring/bar-cycle-loop/bar-cycle-loop.component';
import { BarZoneLoopComponent } from './kpi-loop-time-monitoring/bar-zone-loop/bar-zone-loop.component';
import { BarFamilyStaticComponent } from './kpi-static-time-monitoring/bar-family-static/bar-family-static.component';
import { BarAssetStaticComponent } from './kpi-static-time-monitoring/bar-asset-static/bar-asset-static.component';
import { BarCycleStaticComponent } from './kpi-static-time-monitoring/bar-cycle-static/bar-cycle-static.component';
import { BarFamilyInOutComponent } from './kpi-in-out-zone-monitoring/bar-family-in-out/bar-family-in-out.component';
import { BarAssetInOutComponent } from './kpi-in-out-zone-monitoring/bar-asset-in-out/bar-asset-in-out.component';
import { BarCycleInOutComponent } from './kpi-in-out-zone-monitoring/bar-cycle-in-out/bar-cycle-in-out.component';
import { InZoneAssetsComponent } from './kpi-time-in-zone-monitoring/in-zone-assets/in-zone-assets.component';
import { AssetSelectionComponent } from './kpi-time-in-zone-monitoring/in-zone-assets/asset-selection/asset-selection.component';
import { InZoneCyclesComponent } from './kpi-time-in-zone-monitoring/in-zone-cycles/in-zone-cycles.component';
import { RouterModule } from '@angular/router';
import { NgChartsModule } from 'ng2-charts';
import { hasContextGuard } from 'src/app/auth/has-context.guard';

@NgModule({
    declarations: [
        KpiComponent,
        KpiFilterComponent,
        KpiCycleTimeMonitoringComponent,
        KpiLoopTimeMonitoringComponent,
        KpiTimeInZoneMonitoringComponent,
        KpiInOutZoneMonitoringComponent,
        KpiStaticTimeMonitoringComponent,
        BarAssetsCycleComponent,
        BarCyclesCycleComponent,
        BarFamilyCycleComponent,
        BarZonesCycleComponent,
        TrendFamilyCycleComponent,
        TrendZoneCycleComponent,
        BarAssetLoopComponent,
        BarCycleLoopComponent,
        BarZoneLoopComponent,
        BarFamilyStaticComponent,
        BarAssetStaticComponent,
        BarCycleStaticComponent,
        BarFamilyInOutComponent,
        BarAssetInOutComponent,
        BarCycleInOutComponent,
        InZoneAssetsComponent,
        AssetSelectionComponent,
        InZoneCyclesComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SharedModule,
        FormsModule,
        NgChartsModule,
        OrderbyModule,
        TranslateModule.forChild({ extend: true }),
        AppMaterialModule,
        RouterModule.forChild([
            {
                path: '',
                component: KpiComponent,
                canActivate: [hasContextGuard],
            },
        ]),
    ],
    exports: [
        KpiComponent,
        KpiFilterComponent,
        KpiCycleTimeMonitoringComponent,
        KpiLoopTimeMonitoringComponent,
        KpiTimeInZoneMonitoringComponent,
        KpiInOutZoneMonitoringComponent,
        KpiStaticTimeMonitoringComponent,
    ],


})
export class KpiModule { }
